import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Avatar,
  InputAdornment,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Snackbar,
  Alert,
  CircularProgress,
  Badge,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import AddCardIcon from "@mui/icons-material/AddCard";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentIcon from "@mui/icons-material/Payment";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ReceiptIcon from "@mui/icons-material/Receipt";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  FaBitcoin,
  FaDollarSign,
  FaSterlingSign,
  FaNairaSign,
} from "react-icons/fa6";
import { SiTether } from "react-icons/si";
import Preloader from "./components/Preloader";

import { getExchangeRate } from "./api/exchangeRate";
import {
  blockCard,
  createVirtualCard,
  getCards,
  getVirtualCardDetails,
  initiateCardFunding,
  processCardFunding,
  unblockCard,
} from "./repository/card";
import { clearAuthStorage, getOrganizationSettings } from "./utils/storage";
import { useWallet } from "./api/hooks/useWallet";
import { useCard } from "./api/hooks/useCard";
import { handleLogout } from "./utils/utils";

// Card transactions API function
const getCardTransactions = async (cardId) => {
  const token = localStorage.getItem("token");
  const newOrg = getOrganizationSettings();
  const appid = newOrg.id;

  console.log("Fetching transactions for card:", cardId);
  console.log(
    "API URL:",
    `${process.env.REACT_APP_API_URL}card-mgt/cards/${cardId}/transactions`
  );

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}card-mgt/cards/${cardId}/transactions`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          AppID: appid,
        },
      }
    );
    const data = await response.json();
    console.log("Card transactions response:", data);
    return data;
  } catch (error) {
    console.error("Failed to fetch card transactions:", error);
    return { status: false, message: "Failed to fetch transactions" };
  }
};

export default function Cards({ setSidebarOpen }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // State for create card dialog
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [transactionPin, setTransactionPin] = useState("");
  const [creating, setCreating] = useState(false);

  // State for fund card dialog (multi-step)
  const [fundDialogOpen, setFundDialogOpen] = useState(false);
  const [fundStep, setFundStep] = useState(1); // 1: amount/wallet, 2: confirm+pin
  const [fundAmount, setFundAmount] = useState("");
  const [funding, setFunding] = useState(false);
  const [fundCard, setFundCard] = useState(null);
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");
  const [exchangeInfo, setExchangeInfo] = useState(null);
  const [fundPin, setFundPin] = useState("");
  const [fundError, setFundError] = useState("");
  const [exchangeRateInfo, setExchangeRateInfo] = useState(null);
  const [exchangeRateLoading, setExchangeRateLoading] = useState(false);
  const [exchangeRateError, setExchangeRateError] = useState("");

  // State for card details dialog
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardDetails, setCardDetails] = useState(null);
  const [cardDetailsLoading, setCardDetailsLoading] = useState(false);
  const [cardTransactions, setCardTransactions] = useState([]);
  const [cardTransactionsLoading, setCardTransactionsLoading] = useState(false);

  // State for main page transaction history
  const [allCardTransactions, setAllCardTransactions] = useState([]);
  const [allTransactionsLoading, setAllTransactionsLoading] = useState(false);
  const [selectedCardForTransactions, setSelectedCardForTransactions] =
    useState(null);

  const { data: walletData, isLoading } = useWallet();
  const { data: cardData, isLoading: isCardLoading } = useCard();

  // State for block/unblock dialog
  const [blockDialogOpen, setBlockDialogOpen] = useState(false);
  const [blockCardObj, setBlockCardObj] = useState(null);
  const [blockAction, setBlockAction] = useState("block"); // or 'unblock'
  const [blocking, setBlocking] = useState(false);
  const [blockError, setBlockError] = useState("");

  // Snackbar for fund card success
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  // State for More Dialog
  const [moreDialogOpen, setMoreDialogOpen] = useState(false);

  // State for copy snackbar
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);

  // State for card number visibility
  const [showCardNumbers, setShowCardNumbers] = useState(false);

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch { }

  useEffect(() => {
    if (!cardData) return;

    setTimeout(() => {
      cardData.data.forEach((card) => {
        console.log(
          "Card ID:",
          card.id,
          "Status:",
          card.status,
          "getStatusLabel:",
          getStatusLabel(card),
          "isCardBlocked:",
          isCardBlocked(card)
        );
      });
    }, 100);
    setCards(cardData.data);
    setLoading(false);

    // Fetch transactions for all cards
    if (cardData.data.length > 0) {
      // fetchAllCardTransactions(cardData.data);
    }
  }, [cardData]);

  useEffect(() => {
    if (!walletData) return;

    setWallets(walletData.data);

    if (walletData.data.length > 0) {
      setSelectedWallet(walletData.data[0]);
    }
  }, [walletData]);

  // Function to fetch transactions for all cards
  const fetchAllCardTransactions = async (cardsArray) => {
    setAllTransactionsLoading(true);
    try {
      const allTransactions = [];

      for (const card of cardsArray) {
        try {
          const response = await getCardTransactions(card.id);
          if (response.status && response.data && response.data.transactions) {
            // Add card info to each transaction
            const transactionsWithCardInfo = response.data.transactions.map(
              (tx) => ({
                ...tx,
                card_info: {
                  id: card.id,
                  masked_card_number: card.masked_card_number,
                  card_type: card.card_type,
                  currency: getCurrency(card),
                },
              })
            );
            allTransactions.push(...transactionsWithCardInfo);
          }
        } catch (error) {
          console.error(
            `Failed to fetch transactions for card ${card.id}:`,
            error
          );
        }
      }

      // Sort by date (newest first)
      allTransactions.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setAllCardTransactions(allTransactions);
    } catch (error) {
      console.error("Failed to fetch all card transactions:", error);
    } finally {
      setAllTransactionsLoading(false);
    }
  };

  function getCurrency(card) {
    try {
      const meta = JSON.parse(card?.card_response_metadata || "{}");
      return meta.currency || "USD";
    } catch {
      return "USD";
    }
  }

  function getStatusLabel(card) {
    if (typeof card?.status === "object" && card?.status !== null) {
      return card.status.label || card.status.slug || "Active";
    }
    return card?.status || "Active";
  }

  function isCardBlocked(card) {
    // Check both the label and slug formats
    const statusLabel = getStatusLabel(card).toLowerCase();
    const statusSlug = card.status?.slug?.toLowerCase() || "";

    console.log("isCardBlocked - card status:", card.status);
    console.log("isCardBlocked - getStatusLabel result:", getStatusLabel(card));
    console.log("isCardBlocked - statusLabel.toLowerCase():", statusLabel);
    console.log("isCardBlocked - statusSlug:", statusSlug);

    // Check both label and slug for blocked statuses
    const blockedStatuses = [
      "blocked",
      "frozen",
      "freezed",
      "paused",
      "virtual-paused",
      "virtual paused",
    ];
    const isBlocked =
      blockedStatuses.includes(statusLabel) ||
      blockedStatuses.includes(statusSlug) ||
      statusLabel.includes("paused") ||
      statusLabel.includes("blocked") ||
      statusLabel.includes("frozen") ||
      statusSlug.includes("paused") ||
      statusSlug.includes("blocked") ||
      statusSlug.includes("frozen");

    console.log("isCardBlocked - result:", isBlocked);
    return isBlocked;
  }

  function isCardActive(card) {
    const status = getStatusLabel(card).toLowerCase();
    return status === "active" || status === "successful";
  }

  function getExchangeTarget(card) {
    try {
      const meta = JSON.parse(card?.card_response_metadata || "{}");
      return meta.currency || "USD";
    } catch {
      return "USD";
    }
  }

  const handleCreateCard = () => {
    setCreateDialogOpen(true);
  };

  const handleCreateCardSubmit = async () => {
    if (!transactionPin) {
      return;
    }
    setCreating(true);
    try {
      const response = await createVirtualCard({
        transaction_pin: transactionPin,
      });
      if (response.status) {
        setSnackbarMsg("Card created successfully!");
        setSnackbarOpen(true);
        setCreateDialogOpen(false);
        setTransactionPin("");
        // Refresh cards
        const data = await getCards();
        let cardsArr = (data && data.data && data.data.data) || [];
        setCards(cardsArr);
      } else {
        setError(response.message || "Failed to create card");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to create card");
    } finally {
      setCreating(false);
    }
  };

  const handleViewDetails = (card) => {
    setSelectedCard(card);
    setDetailsDialogOpen(true);
    setCardDetailsLoading(true);

    // Fetch card details
    getVirtualCardDetails(card.id)
      .then((res) => {
        setCardDetails(res.data || res);
        setCardDetailsLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch card details:", err);
        setCardDetailsLoading(false);
      });
  };

  const handleFundCard = (card) => {
    setFundCard(card);
    setFundDialogOpen(true);
    setFundStep(1);
    setFundAmount("");
    setFundError("");
    setExchangeInfo(null);
    setExchangeRateInfo(null);
  };

  const handleFundStep1 = async () => {
    if (!fundAmount || !selectedWallet) return;
    setFunding(true);
    setFundError("");
    try {
      const response = await initiateCardFunding({
        card_id: fundCard.id,
        source_wallet_number_or_uuid: selectedWallet,
        amount: fundAmount,
      });
      if (response.status) {
        setExchangeInfo(response.data);
        setFundStep(2);
      } else {
        setFundError(response.message || "Failed to initiate funding");
      }
    } catch (err) {
      setFundError(
        err?.response?.data?.message || "Failed to initiate funding"
      );
    } finally {
      setFunding(false);
    }
  };

  const handleFundStep2 = async () => {
    if (!fundPin) return;
    setFunding(true);
    setFundError("");
    try {
      const response = await processCardFunding({
        card_id: fundCard.id,
        transaction_pin: fundPin,
      });
      if (response.status) {
        setSnackbarMsg("Card funded successfully!");
        setSnackbarOpen(true);
        setFundDialogOpen(false);
        setFundPin("");
        setFundStep(1);
        // Refresh cards
        const data = await getCards();
        let cardsArr = (data && data.data && data.data.data) || [];
        setCards(cardsArr);
      } else {
        setFundError(response.message || "Failed to fund card");
      }
    } catch (err) {
      setFundError(err?.response?.data?.message || "Failed to fund card");
    } finally {
      setFunding(false);
    }
  };

  const handleBlockUnblock = (card) => {
    console.log("Card status:", card.status);
    console.log("Card status object:", card.status);
    setBlockCardObj(card);
    setBlockAction(isCardBlocked(card) ? "unblock" : "block");
    setBlockDialogOpen(true);
    setBlockError("");
  };

  const handleBlockCardConfirm = async () => {
    if (!blockCardObj) return;
    setBlocking(true);
    setBlockError("");
    try {
      const response =
        blockAction === "block"
          ? await blockCard(blockCardObj.id)
          : await unblockCard(blockCardObj.id);

      if (response.status) {
        setSnackbarMsg(`Card ${blockAction}ed successfully!`);
        setSnackbarOpen(true);
        setBlockDialogOpen(false);
        // Refresh cards
        const data = await getCards();
        let cardsArr = (data && data.data && data.data.data) || [];
        setCards(cardsArr);
      } else {
        setBlockError(response.message || `Failed to ${blockAction} card`);
      }
    } catch (err) {
      setBlockError(
        err?.response?.data?.message || `Failed to ${blockAction} card`
      );
    } finally {
      setBlocking(false);
    }
  };

  // Exchange rate fetching
  useEffect(() => {
    if (fundAmount && selectedWallet && fundCard) {
      async function fetchRate() {
        setExchangeRateLoading(true);
        setExchangeRateError("");
        try {
          // Get the source wallet currency
          const sourceWallet = wallets.find(
            (w) => w.wallet_number === selectedWallet || w.id === selectedWallet
          );
          const sourceCurrency = sourceWallet?.currency?.code || "NGN";

          // Get the card currency
          const cardCurrency = getCurrency(fundCard);

          const response = await getExchangeRate({
            from: sourceCurrency,
            to: cardCurrency,
            amount: fundAmount,
          });
          if (response.status) {
            setExchangeRateInfo(response.data);
          } else {
            setExchangeRateError(
              response.message || "Failed to get exchange rate"
            );
          }
        } catch (err) {
          setExchangeRateError(
            err?.response?.data?.message || "Failed to get exchange rate"
          );
        } finally {
          setExchangeRateLoading(false);
        }
      }
      const timeoutId = setTimeout(fetchRate, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [fundAmount, selectedWallet, fundCard]);

  const handleCopyCardNumber = (number) => {
    navigator.clipboard.writeText(number);
    setCopySnackbarOpen(true);
  };

  // Helper functions
  const getCardBalance = (card) => {
    try {
      const meta = JSON.parse(card?.card_response_metadata || "{}");
      return meta.balance || "0.00";
    } catch {
      return "0.00";
    }
  };

  const getCardStatusColor = (card) => {
    const status = getStatusLabel(card).toLowerCase();
    if (isCardActive(card)) return "success";
    if (isCardBlocked(card) || status === "failed") return "error";
    if (status === "pending") return "warning";
    return "default";
  };

  const getCardStatusIcon = (card) => {
    const status = getStatusLabel(card).toLowerCase();
    if (isCardBlocked(card)) return <BlockIcon className="text-red-500" />;
    if (isCardActive(card)) return <LockOpenIcon className="text-green-500" />;
    return <CreditCardIcon className="text-gray-500" />;
  };

  if (loading)
    return <Preloader fullScreen={true} message="Loading your cards..." />;
  if (error)
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
        <div className="fintech-card p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-danger-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <CreditCardIcon className="text-danger-600 text-2xl" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Failed to Load Cards
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Try Again
          </button>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <button
              onClick={() => setSidebarOpen && setSidebarOpen(true)}
              className="block xl:hidden text-gray-600 hover:text-gray-900 p-1"
            >
              <MenuIcon />
            </button>
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">
                Virtual Cards
              </h1>
              <p className="text-sm text-gray-600 truncate">
                Manage your virtual cards and transactions
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handleCreateCard}
              className="btn-primary text-sm py-2 px-4"
            >
              <AddCardIcon className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Create Card</span>
              <span className="sm:hidden">Create</span>
            </button>
            <button
              onClick={handleLogout}
              className="text-gray-600 hover:text-red-600 transition p-1 flex-shrink-0"
            >
              <LogoutIcon />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8">
        {cards.length === 0 ? (
          // Empty State
          <div className="text-center py-12">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CreditCardIcon className="text-gray-400 text-4xl" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              No Virtual Cards
            </h3>
            <p className="text-gray-600 mb-6">
              Create your first virtual card to start making secure online
              payments
            </p>
            <button onClick={handleCreateCard} className="btn-primary">
              <AddCardIcon className="w-4 h-4 mr-2" />
              Create Your First Card
            </button>
          </div>
        ) : (
          <>
            {/* Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 sm:gap-8 mb-8">
              {cards.map((card, index) => (
                <div
                  key={card.id}
                  className="fintech-card animate-slide-up"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="flex flex-col lg:flex-row gap-8 p-5">
                    {/* Card Visual */}
                    <div className="relative lg:w-1/2">
                      <div className="relative w-full h-72 sm:h-80 lg:h-85 rounded-2xl overflow-hidden shadow-2xl">
                        <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-blue-900 to-indigo-900"></div>
                        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/5 to-transparent"></div>
                        <div className="absolute inset-0 bg-gradient-to-tl from-black/30 to-transparent"></div>
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-purple-500/20 to-transparent"></div>

                        {/* Card Header */}
                        <div className="absolute top-6 left-6 right-6 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <Chip
                              label={getStatusLabel(card)}
                              color={getCardStatusColor(card)}
                              size="small"
                              icon={getCardStatusIcon(card)}
                              className="bg-white/25 text-white border-white/40 backdrop-blur-sm"
                            />
                          </div>
                          <div className="flex items-center gap-2">
                            <IconButton
                              size="small"
                              onClick={() =>
                                setShowCardNumbers(!showCardNumbers)
                              }
                              className="text-white hover:text-white hover:bg-white/20"
                            >
                              {showCardNumbers ? (
                                <VisibilityOffIcon className="text-white" />
                              ) : (
                                <VisibilityIcon className="text-white" />
                              )}
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleCopyCardNumber(card.masked_card_number)
                              }
                              className="text-white hover:text-white hover:bg-white/20"
                            >
                              <ContentCopyIcon className="text-white" />
                            </IconButton>
                          </div>
                        </div>

                        {/* Card Number */}
                        <div className="absolute top-24 sm:top-32 left-4 sm:left-6 right-4 sm:right-6">
                          <div className="text-white font-mono text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold tracking-widest drop-shadow-lg">
                            {showCardNumbers
                              ? card.card_number || card.masked_card_number
                              : card.masked_card_number}
                          </div>
                        </div>

                        {/* CVV */}
                        <div className="absolute top-40 sm:top-52 left-4 sm:left-6">
                          <div className="text-white/95">
                            <div className="text-xs sm:text-sm opacity-80 font-medium">
                              CVV
                            </div>
                            <div className="font-mono font-semibold text-sm sm:text-base drop-shadow-sm">
                              {showCardNumbers
                                ? card.cvv || card.cvv_code || "***"
                                : "***"}
                            </div>
                          </div>
                        </div>

                        {/* Card Details */}
                        <div className="absolute bottom-4 sm:bottom-8 left-4 sm:left-6 right-4 sm:right-6">
                          <div className="flex items-center justify-between text-white/95">
                            <div>
                              <div className="text-xs sm:text-sm opacity-80 font-medium">
                                Card Holder
                              </div>
                              <div className="font-semibold text-sm sm:text-base drop-shadow-sm truncate">
                                {card.embossed_name || user?.name || "N/A"}
                              </div>
                            </div>
                            <div className="text-right pr-20 sm:pr-24">
                              <div className="text-xs sm:text-sm opacity-80 font-medium">
                                Expires
                              </div>
                              <div className="font-semibold text-sm sm:text-base drop-shadow-sm">
                                {card.expiration_date || "MM/YY"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Network Logo */}
                        <div className="absolute bottom-4 sm:bottom-8 right-4 sm:right-6">
                          <div className="w-16 h-10 sm:w-20 sm:h-12 bg-white/25 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/20">
                            <CreditCardIcon className="text-white text-2xl sm:text-3xl drop-shadow-sm" />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Card Info */}
                    <div className="lg:w-1/2 space-y-6 lg:min-h-96 lg:flex lg:flex-col lg:justify-between">
                      {/* Balance */}
                      <div className="flex items-center justify-between p-8 bg-gradient-to-r from-gray-50 to-gray-100 rounded-3xl border border-gray-200/50 shadow-lg">
                        <div className="flex items-center gap-6">
                          <div className="w-16 h-16 bg-gradient-to-br from-primary-100 to-primary-200 rounded-3xl flex items-center justify-center shadow-md">
                            <AttachMoneyIcon className="text-primary-600 text-2xl" />
                          </div>
                          <div>
                            <div className="text-base text-gray-600 font-medium">
                              Balance
                            </div>
                            <div className="text-3xl font-bold text-gray-900">
                              ${getCardBalance(card)}
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-base text-gray-600 font-medium">
                            Currency
                          </div>
                          <div className="text-2xl font-semibold text-gray-900">
                            {getCurrency(card)}
                          </div>
                        </div>
                      </div>

                      {/* Quick Stats */}
                      <div className="grid grid-cols-2 gap-6">
                        <div className="p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-3xl text-center border border-green-200/50 shadow-lg">
                          <div className="text-base text-green-600 font-medium mb-2">
                            Cashback
                          </div>
                          <div className="text-2xl font-bold text-green-700">
                            +${card.cashback || "0.00"}
                          </div>
                        </div>
                        <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl text-center border border-blue-200/50 shadow-lg">
                          <div className="text-base text-blue-600 font-medium mb-2">
                            This Month
                          </div>
                          <div className="text-2xl font-bold text-blue-700">
                            ${card.spent_this_month || "0.00"}
                          </div>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="grid grid-cols-3 gap-4 lg:mt-auto">
                        <button
                          onClick={() => handleFundCard(card)}
                          className="btn-primary text-base py-5 px-6 flex items-center justify-center rounded-2xl"
                        >
                          <AttachMoneyIcon className="w-5 h-5 mr-2" />
                          <span className="hidden sm:inline">Fund</span>
                          <span className="sm:hidden">Fund</span>
                        </button>
                        <button
                          onClick={() => handleBlockUnblock(card)}
                          className={`btn-secondary text-base py-5 px-6 flex items-center justify-center rounded-2xl ${(() => {
                            const blocked = isCardBlocked(card);
                            console.log(
                              "Button rendering - card ID:",
                              card.id,
                              "isBlocked:",
                              blocked
                            );
                            return blocked;
                          })()
                            ? "text-green-600 border-green-200 hover:bg-green-50"
                            : "text-orange-600 border-orange-200 hover:bg-orange-50"
                            }`}
                        >
                          {(() => {
                            const blocked = isCardBlocked(card);
                            console.log(
                              "Button text - card ID:",
                              card.id,
                              "isBlocked:",
                              blocked
                            );
                            return blocked;
                          })() ? (
                            <>
                              <LockOpenIcon className="w-5 h-5 mr-2" />
                              <span className="hidden sm:inline">Unfreeze</span>
                              <span className="sm:hidden">Unfreeze</span>
                            </>
                          ) : (
                            <>
                              <BlockIcon className="w-5 h-5 mr-2" />
                              <span className="hidden sm:inline">Freeze</span>
                              <span className="sm:hidden">Freeze</span>
                            </>
                          )}
                        </button>
                        <button
                          onClick={() => handleViewDetails(card)}
                          className="text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-2xl transition-all duration-200 text-base font-medium border border-gray-200 py-5 px-6 flex items-center justify-center"
                        >
                          <span className="hidden sm:inline">Details</span>
                          <span className="sm:hidden">Details</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Card Transaction History */}
            <div className="fintech-card">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-xl font-bold text-gray-900">
                      Card Transaction History
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                      Recent transactions across all your cards
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => fetchAllCardTransactions(cards)}
                      disabled={allTransactionsLoading}
                      className="btn-secondary text-sm py-2 px-3"
                    >
                      {allTransactionsLoading ? (
                        <CircularProgress size={16} />
                      ) : (
                        <>
                          <ReceiptIcon className="w-4 h-4 mr-1" />
                          Refresh
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="p-6">
                {allTransactionsLoading ? (
                  <div className="text-center py-8">
                    <CircularProgress />
                    <p className="text-gray-600 mt-2">
                      Loading transactions...
                    </p>
                  </div>
                ) : allCardTransactions.length === 0 ? (
                  <div className="text-center py-8">
                    <ReceiptIcon className="text-gray-400 text-4xl mx-auto mb-4" />
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      No Transactions
                    </h3>
                    <p className="text-gray-600">
                      No card transactions found. Start using your cards to see
                      transaction history.
                    </p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Card
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Date
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Amount
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Description
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Reference
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {allCardTransactions.slice(0, 10).map((tx) => (
                          <tr
                            key={tx.id}
                            className="border-b border-gray-100 hover:bg-gray-50"
                          >
                            <td className="py-3 px-4">
                              <div className="flex items-center gap-2">
                                <div className="w-8 h-5 bg-gradient-to-r from-blue-500 to-purple-600 rounded flex items-center justify-center">
                                  <CreditCardIcon className="text-white text-xs" />
                                </div>
                                <div>
                                  <div className="text-sm font-medium text-gray-900">
                                    ••••{" "}
                                    {tx.card_info?.masked_card_number?.slice(
                                      -4
                                    ) || "****"}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    {tx.card_info?.card_type || "Virtual"}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-4 text-sm text-gray-900">
                              {tx.created_at
                                ? new Date(tx.created_at).toLocaleString()
                                : "-"}
                            </td>
                            <td className="py-3 px-4 text-sm font-medium text-gray-900">
                              $
                              {parseFloat(tx.amount || 0).toLocaleString(
                                undefined,
                                { minimumFractionDigits: 2 }
                              )}
                            </td>
                            <td className="py-3 px-4 text-sm text-gray-900">
                              {tx.transaction_type || tx.type || "-"}
                            </td>
                            <td className="py-3 px-4">
                              <span
                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${tx.status === "completed"
                                  ? "bg-green-100 text-green-800"
                                  : tx.status === "pending"
                                    ? "bg-yellow-100 text-yellow-800"
                                    : tx.status === "failed"
                                      ? "bg-red-100 text-red-800"
                                      : "bg-gray-100 text-gray-800"
                                  }`}
                              >
                                <span
                                  className={`w-2 h-2 rounded-full mr-1 ${tx.status === "completed"
                                    ? "bg-green-400"
                                    : tx.status === "pending"
                                      ? "bg-yellow-400"
                                      : tx.status === "failed"
                                        ? "bg-red-400"
                                        : "bg-gray-400"
                                    }`}
                                ></span>
                                {tx.status || "Unknown"}
                              </span>
                            </td>
                            <td className="py-3 px-4 text-sm text-gray-900">
                              {tx.description || tx.narration || "-"}
                            </td>
                            <td className="py-3 px-4 text-sm text-gray-900 font-mono">
                              {tx.reference_number || tx.reference || "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {allCardTransactions.length > 10 && (
                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                      Showing 10 of {allCardTransactions.length} transactions
                    </p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {/* Snackbars */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity="success"
            sx={{ width: "100%" }}
            elevation={6}
            variant="filled"
          >
            {snackbarMsg}
          </Alert>
        </Snackbar>

        <Snackbar
          open={copySnackbarOpen}
          autoHideDuration={2000}
          onClose={() => setCopySnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setCopySnackbarOpen(false)}
            severity="info"
            sx={{ width: "100%" }}
            elevation={6}
            variant="filled"
          >
            Card number copied to clipboard!
          </Alert>
        </Snackbar>

        {/* Create Card Dialog */}
        <Dialog
          open={createDialogOpen}
          onClose={() => setCreateDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="flex items-center gap-2">
            <AddCardIcon className="text-primary-600" />
            Create Virtual Card
          </DialogTitle>
          <DialogContent>
            <div className="space-y-4 pt-2">
              <div className="p-4 bg-blue-50 rounded-xl">
                <div className="flex items-center gap-2 mb-2">
                  <InfoIcon className="text-blue-600" />
                  <div className="font-medium text-blue-900">
                    Virtual Card Benefits
                  </div>
                </div>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• Secure online payments</li>
                  <li>• Instant card creation</li>
                  <li>• Real-time spending control</li>
                  <li>• Cashback rewards</li>
                </ul>
              </div>

              <TextField
                label="Transaction PIN"
                type="password"
                fullWidth
                value={transactionPin}
                onChange={(e) => setTransactionPin(e.target.value)}
                placeholder="Enter your 4-digit PIN"
                inputProps={{ maxLength: 4, pattern: "[0-9]*" }}
                helperText="Enter your 4-digit transaction PIN to create the card"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setCreateDialogOpen(false)}
              disabled={creating}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCreateCardSubmit}
              variant="contained"
              color="primary"
              disabled={
                creating || !transactionPin || transactionPin.length !== 4
              }
              startIcon={
                creating ? <CircularProgress size={16} /> : <AddCardIcon />
              }
            >
              {creating ? "Creating..." : "Create Card"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Fund Card Dialog */}
        <Dialog
          open={fundDialogOpen}
          onClose={() => setFundDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="flex items-center gap-2">
            <AttachMoneyIcon className="text-primary-600" />
            Fund Card
            {fundCard && (
              <Chip
                label={`•••• ${fundCard.masked_card_number?.slice(-4)}`}
                size="small"
                className="ml-2"
              />
            )}
          </DialogTitle>
          <DialogContent>
            {fundStep === 1 && (
              <div className="space-y-4 pt-2">
                <TextField
                  select
                  label="Source Wallet"
                  value={selectedWallet}
                  onChange={(e) => setSelectedWallet(e.target.value)}
                  fullWidth
                  error={!selectedWallet}
                  helperText={
                    !selectedWallet ? "Please select a source wallet" : ""
                  }
                  disabled={wallets.length === 0}
                >
                  {wallets
                    .filter(
                      (w) =>
                        (w.wallet_number && /^\d{10}$/.test(w.wallet_number)) ||
                        (w.id && w.id.length >= 10)
                    )
                    .map((w) => {
                      const value =
                        w.wallet_number && /^\d{10}$/.test(w.wallet_number)
                          ? w.wallet_number
                          : w.id;
                      return (
                        <MenuItem key={value} value={value}>
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-primary-100 rounded-lg flex items-center justify-center">
                              {w.currency?.code === "NGN" ? (
                                <span className="text-lg">🇳🇬</span>
                              ) : w.currency?.code === "USD" ? (
                                <span className="text-lg">🇺🇸</span>
                              ) : w.currency?.code === "GBP" ? (
                                <FaSterlingSign />
                              ) : w.currency?.code === "USDT" ? (
                                <SiTether />
                              ) : (
                                <FaDollarSign />
                              )}
                            </div>
                            <div>
                              <div className="font-medium">
                                {w.ownership_label || w.wallet_number || w.id}
                              </div>
                              <div className="text-sm text-gray-500">
                                {w.currency?.code || "N/A"}
                              </div>
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })}
                </TextField>

                <TextField
                  autoFocus
                  label="Amount"
                  type="number"
                  fullWidth
                  value={fundAmount}
                  onChange={(e) => setFundAmount(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                    inputProps: { min: 1 },
                  }}
                  placeholder="Enter amount to fund"
                />

                {exchangeRateLoading && (
                  <div className="flex items-center gap-2 text-primary-600">
                    <CircularProgress size={16} />
                    Getting exchange rate...
                  </div>
                )}

                {exchangeRateInfo && (
                  <div className="p-4 bg-gray-50 rounded-xl">
                    <div className="text-sm font-medium text-gray-700 mb-2">
                      Exchange Rate Preview
                    </div>
                    <div className="space-y-1 text-sm">
                      <div className="flex justify-between">
                        <span>Rate:</span>
                        <span className="font-medium">
                          {exchangeRateInfo.exchange_rate}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>You'll receive:</span>
                        <span className="font-medium text-green-600">
                          {exchangeRateInfo.quote_currency}{" "}
                          {exchangeRateInfo.quote_amount}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {exchangeRateError && (
                  <Alert severity="warning" className="mt-2">
                    {exchangeRateError}
                  </Alert>
                )}

                {fundError && (
                  <Alert severity="error" className="mt-2">
                    {fundError}
                  </Alert>
                )}
              </div>
            )}

            {fundStep === 2 && exchangeInfo && (
              <div className="space-y-4 pt-2">
                <div className="p-4 bg-blue-50 rounded-xl">
                  <div className="text-sm font-medium text-blue-900 mb-3">
                    Funding Summary
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span>From:</span>
                      <span className="font-medium">
                        {exchangeInfo.source_wallet_currency_code} (
                        {exchangeInfo.source_wallet_currency_symbol})
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span>Amount:</span>
                      <span className="font-medium">
                        {exchangeInfo.source_wallet_debit_amount}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span>Fee:</span>
                      <span className="font-medium text-red-600">
                        {exchangeInfo.source_wallet_charge_amount}
                      </span>
                    </div>
                    <Divider />
                    <div className="flex justify-between">
                      <span>Exchange Rate:</span>
                      <span className="font-medium">
                        {exchangeInfo.exchange_rate}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span>Card Receives:</span>
                      <span className="font-medium text-green-600">
                        {exchangeInfo.destination_card_currency_code}{" "}
                        {exchangeInfo.destination_card_final_amount}
                      </span>
                    </div>
                  </div>
                </div>

                <TextField
                  label="Transaction PIN"
                  type="password"
                  fullWidth
                  value={fundPin}
                  onChange={(e) => setFundPin(e.target.value)}
                  placeholder="Enter your 6-digit PIN"
                  inputProps={{ maxLength: 6, pattern: "[0-9]*" }}
                />

                {fundError && (
                  <Alert severity="error" className="mt-2">
                    {fundError}
                  </Alert>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFundDialogOpen(false)} disabled={funding}>
              Cancel
            </Button>
            {fundStep === 1 && (
              <Button
                onClick={handleFundStep1}
                variant="contained"
                color="primary"
                disabled={
                  funding ||
                  !fundAmount ||
                  Number(fundAmount) <= 0 ||
                  !selectedWallet
                }
                startIcon={funding ? <CircularProgress size={16} /> : null}
              >
                {funding ? "Checking..." : "Next"}
              </Button>
            )}
            {fundStep === 2 && (
              <Button
                onClick={handleFundStep2}
                variant="contained"
                color="primary"
                disabled={funding || !fundPin}
                startIcon={
                  funding ? <CircularProgress size={16} /> : <AttachMoneyIcon />
                }
              >
                {funding ? "Processing..." : "Fund Card"}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Card Details Dialog */}
        <Dialog
          open={detailsDialogOpen}
          onClose={() => setDetailsDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle className="flex items-center gap-2">
            <CreditCardIcon className="text-primary-600" />
            Card Details
            {selectedCard && (
              <Chip
                label={`•••• ${selectedCard.masked_card_number?.slice(-4)}`}
                size="small"
                className="ml-2"
              />
            )}
          </DialogTitle>
          <DialogContent>
            {cardDetailsLoading ? (
              <div className="flex items-center justify-center py-8">
                <CircularProgress />
              </div>
            ) : cardDetails ? (
              <div className="space-y-6 pt-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Card Number
                      </label>
                      <div className="flex items-center gap-2">
                        <div className="font-mono text-lg font-bold text-gray-900">
                          {showCardNumbers
                            ? selectedCard.masked_card_number
                            : "•••• •••• •••• ••••"}
                        </div>
                        <IconButton
                          size="small"
                          onClick={() => setShowCardNumbers(!showCardNumbers)}
                        >
                          {showCardNumbers ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleCopyCardNumber(
                              selectedCard.masked_card_number
                            )
                          }
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Card Holder
                      </label>
                      <div className="text-base sm:text-lg font-semibold text-gray-900">
                        {selectedCard.embossed_name || user?.name || "N/A"}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Expiry Date
                      </label>
                      <div className="text-base sm:text-lg font-semibold text-gray-900">
                        {selectedCard.expiration_date || "MM/YY"}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        CVV
                      </label>
                      <div className="flex items-center gap-2 flex-wrap">
                        <div className="font-mono text-sm sm:text-base md:text-lg font-semibold text-gray-900 min-w-0 flex-1">
                          {showCardNumbers
                            ? selectedCard.cvv || selectedCard.cvv_code || "***"
                            : "***"}
                        </div>
                        <IconButton
                          size="small"
                          onClick={() => setShowCardNumbers(!showCardNumbers)}
                          className="flex-shrink-0"
                        >
                          {showCardNumbers ? (
                            <VisibilityOffIcon className="text-white" />
                          ) : (
                            <VisibilityIcon className="text-white" />
                          )}
                        </IconButton>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Status
                      </label>
                      <Chip
                        label={getStatusLabel(selectedCard)}
                        color={getCardStatusColor(selectedCard)}
                        icon={getCardStatusIcon(selectedCard)}
                      />
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Current Balance
                      </label>
                      <div className="text-2xl font-bold text-gray-900">
                        ${getCardBalance(selectedCard)}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Currency
                      </label>
                      <div className="text-lg font-semibold text-gray-900">
                        {getCurrency(selectedCard)}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Card Type
                      </label>
                      <div className="text-lg font-semibold text-gray-900">
                        {selectedCard.card_type || "Virtual"}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Network
                      </label>
                      <div className="text-lg font-semibold text-gray-900">
                        {selectedCard.card_network_type || "VIRTUAL"}
                      </div>
                    </div>
                  </div>
                </div>

                {cardDetails.billing_address && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Billing Address
                    </label>
                    <div className="p-4 bg-gray-50 rounded-xl">
                      <div className="text-gray-900">
                        {cardDetails.billing_address.street}
                        <br />
                        {cardDetails.billing_address.city},{" "}
                        {cardDetails.billing_address.state}{" "}
                        {cardDetails.billing_address.postal_code}
                        <br />
                        {cardDetails.billing_address.country}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                No details available for this card
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDetailsDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Freeze/Unfreeze Card Dialog */}
        <Dialog
          open={blockDialogOpen}
          onClose={() => setBlockDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="flex items-center gap-2">
            <WarningAmberIcon
              color={blockAction === "block" ? "error" : "warning"}
            />
            {blockAction === "block" ? "Freeze Card" : "Unfreeze Card"}
          </DialogTitle>
          <DialogContent>
            <div className="space-y-4 pt-2">
              <div className="p-4 bg-orange-50 rounded-xl">
                <div className="flex items-center gap-2 mb-2">
                  <WarningAmberIcon className="text-orange-600" />
                  <div className="font-medium text-orange-900">
                    {blockAction === "block" ? "Freeze Card" : "Unfreeze Card"}
                  </div>
                </div>
                <p className="text-sm text-orange-800">
                  {blockCardObj &&
                    `Are you sure you want to ${blockAction === "block" ? "freeze" : "unfreeze"
                    } card ending in ${blockCardObj.masked_card_number?.slice(-4) || "****"
                    }?`}
                </p>
                <p className="text-sm text-orange-700 mt-2">
                  {blockAction === "block"
                    ? "This will prevent the card from being used for transactions. You can unblock it later."
                    : "This will allow the card to be used for transactions again."}
                </p>
              </div>

              {blockError && <Alert severity="error">{blockError}</Alert>}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setBlockDialogOpen(false)}
              disabled={blocking}
            >
              Cancel
            </Button>
            <Button
              onClick={handleBlockCardConfirm}
              variant="contained"
              color={blockAction === "block" ? "error" : "warning"}
              disabled={blocking}
              startIcon={blocking ? <CircularProgress size={16} /> : null}
            >
              {blocking
                ? blockAction === "block"
                  ? "Freezing..."
                  : "Unfreezing..."
                : blockAction === "block"
                  ? "Freeze Card"
                  : "Unfreeze Card"}
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </div>
  );
}
